'use client'
import { IReview } from '@/_types'
import { Box, Heading, Stack, StackSeparator, Text } from '@chakra-ui/react'
import Card from './components/Card'
import BottomSheet from '@/_components/Sheet'
import { useTranslations } from 'next-intl'

const CommentMobile = ({
  isOpen,
  onClose,
  reviews,
}: {
  isOpen: boolean
  onClose: () => void
  reviews?: IReview[]
}) => {
  const t = useTranslations()

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} zIndex={1401}>
      <Box px={4} overflow={'auto'} h={'full'}>
        <Text>{t('reviews')}</Text>
        <Stack separator={<StackSeparator />}>
          {reviews && reviews?.length > 0 ? (
            reviews?.map((el) => <Card key={el.id} data={el} />)
          ) : (
            <Text textAlign={'center'} my={4} fontSize={'lg'} fontWeight={600}>
              {t('no_reviews')}
            </Text>
          )}
        </Stack>
      </Box>
    </BottomSheet>
  )
}

export default CommentMobile
